import { DateTimeValue } from '../../data-objects/field-values/date-time.class'
import {
  DateTimeFieldAccuracy,
  DateTimeFieldBehaviour,
  DateTimeFieldFormat,
  DateTimeFieldVisualization,
} from '../enums'
import { FieldDefinition } from './field-definition'

export class DateTimeFieldDefinition extends FieldDefinition {
  public accuracyRequested: DateTimeFieldAccuracy
  public behaviour: DateTimeFieldBehaviour
  public visualization: DateTimeFieldVisualization
  public format: DateTimeFieldFormat
  public allowUnknown: boolean

  constructor(el: DateTimeFieldDefinition) {
    super(el)
    this.accuracyRequested = el.accuracyRequested
    this.behaviour = el.behaviour
    this.visualization = el.visualization
    this.format = el.format
    this.allowUnknown = el.allowUnknown
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getFieldValue(): any {
    const toReturn = new DateTimeValue()
    toReturn.accuracy = this.accuracyRequested
    toReturn.kind = this.behaviour
    return toReturn
  }
}
